import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from '@mui/material';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomConfirmDialog = ({title, children, open, handleClose, handleConfirm, noText = 'No', yesText='Yes', loading=false, success=false }) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();  // Only close when it's not a backdrop click
        }
      }}
      TransitionComponent={Transition}
      disableEscapeKeyDown  
      aria-labelledby="deactivate-dialog-title"
      aria-describedby="deactivate-dialog-description"
      sx={{ '& .MuiDialog-paper': { minWidth: '400px' } }} 
    >
      <DialogTitle id="deactivate-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="deactivate-dialog-description">
          {children}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
      {(!loading && !success) && (
           <>
            <Button onClick={handleClose} color="secondary">
              {noText}
            </Button>
            <Button onClick={handleConfirm}  variant="contained" color="primary" autoFocus>
              {yesText}
            </Button>
          </>
       )}
      </DialogActions>
    </Dialog>
  );
};

export default CustomConfirmDialog